import React, { useState } from "react";
import { Button, Checkbox, Space } from "antd";
import moment from "moment";
import { Typography } from "antd";
import { DatePicker } from "../antOverrides";
import { setActiveEvent } from "../../features/plan/PlanSlice";
import { useDispatch } from "react-redux";
import { convertPlanEventFromCalender } from "../util/helpers";
import { FormattedMessage } from "react-intl";
import Walkthrough from "./Walkthrough";
import EmployeeDetails from "./EmployeeDetails";
import ProviderTariffSelector from "./ProviderTariffSelector";
import OncallSelector from "./OncallSelector";
import TimeRangePicker from "../util/TimeRangePicker";
import { useIntl } from "react-intl";
const { Title, Text } = Typography;

const EditEventDetails = (props) => {
  const {
    activeEvent = {},
    title,
    removeEvent,
    type,
    editLoading,
    changeEvent,
    changeActiveEvent,
    onChangeSlide,
    orders,
    fromEmployee,
  } = props;

  const dispatch = useDispatch();
  const intl = useIntl();

  const [endOnNextDay, setEndOnNextDay] = useState(() => {
    if (activeEvent && activeEvent.start && activeEvent.end) {
      return (
        moment(activeEvent.end).date() !== moment(activeEvent.start).date()
      );
    }
    return false;
  });

  const onDateChange = (date) => {
    const start = moment(activeEvent?.start);
    const end = moment(activeEvent?.end);
    const newStart = moment(date);
    const newEnd = moment(date);
    if (date) {
      newStart.set({
        hour: start.get("hour"),
        minute: start.get("minute"),
      });
      newEnd.set({
        hour: end.get("hour"),
        minute: end.get("minute"),
      });
      if (endOnNextDay) {
        newEnd.add(1, "day");
      }
    }

    const change = {
      start: newStart.toDate(),
      end: newEnd.toDate(),
      date: newStart.format(),
    };

    onChangeEvent(change);
  };

  const disabledDate = (current) => {
    return (
      current &&
      activeEvent &&
      activeEvent.date &&
      (current < moment(activeEvent.date).startOf("month") ||
        current > moment(activeEvent.date).endOf("month"))
    );
  };

  const onStartChange = (val) => {
    if (!val) {
      const date = moment(activeEvent.date);
      let start = date.clone();
      start.set({
        hour: 12,
        minute: 0,
      });
      onChangeEvent({ start, end: start });
      return;
    }

    const start = moment(val);
    let end = moment(activeEvent.end);

    if (endOnNextDay) {
      end = start
        .clone()
        .add(1, "day")
        .set({
          hour: end.get("hour"),
          minute: end.get("minute"),
        });
    } else {
      end = start.clone().set({
        hour: end.get("hour"),
        minute: end.get("minute"),
      });
    }

    const isDisabledHour = start >= end;

    if (!isDisabledHour) {
      onChangeEvent({
        start: start.toDate(),
        end: end.toDate(),
      });
    }
  };

  const onEndChange = (val) => {
    if (!val) {
      if (activeEvent.start) {
        // If val is null, set end to start hour
        const newEnd = moment(activeEvent.start);
        onChangeEvent({ end: newEnd.toDate() });
      } else {
        onChangeEvent({ end: null });
      }
      return;
    }
    if (!activeEvent.start) {
      const date = moment(activeEvent.date);
      let end = date.clone();
      end.set({
        hour: val.get("hour"),
        minute: val.get("minute"),
      });

      onChangeEvent({ end: end.toDate(), start: end.toDate() });
      return;
    }

    const start = moment(activeEvent.start);
    let end = endOnNextDay ? start.clone().add(1, "day") : start.clone();

    end.set({
      hour: val.get("hour"),
      minute: val.get("minute"),
    });

    if (!endOnNextDay && end.isBefore(start)) {
      // If end time is before start time, set end to start hour
      end = start.clone();
    }

    onChangeEvent({ end: end.toDate() });
  };

  const onEndOnNextDayChange = (e) => {
    const isChecked = e.target.checked;
    setEndOnNextDay(isChecked);

    const start = moment(activeEvent.start);
    let end = moment(activeEvent.end);

    if (isChecked) {
      // If checked, set end to next day
      end = start
        .clone()
        .add(1, "day")
        .set({
          hour: end.get("hour"),
          minute: end.get("minute"),
        });
    } else {
      // If unchecked, set end to same day as start
      end = start.clone().set({
        hour: end.get("hour"),
        minute: end.get("minute"),
      });

      // If end time is before start time, set end to start hour
      if (end.isBefore(start)) {
        end = start.clone();
      }
    }

    onChangeEvent({ end: end.toDate() });
  };

  const onChangeEvent = (change) => {
    const changed = {
      ...activeEvent,
      ...change,
    };
    const converted = convertPlanEventFromCalender(changed);
    if (type === "scheduling") {
      changeActiveEvent(changed);
    } else {
      dispatch(setActiveEvent(converted));
    }
  };

  const onSelectProviderTariff = (val) => {
    if (type === "scheduling") {
      changeActiveEvent({ ...activeEvent, client_tariff_id: val });
    } else {
      dispatch(setActiveEvent({ ...activeEvent, client_tariff_id: val }));
    }
  };

  const onOncallChange = (val) => {
    changeActiveEvent({ ...activeEvent, oncall: val });
  };

  const submitChanges = () => {
    if (type === "scheduling") {
      changeEvent(activeEvent, activeEvent.start, activeEvent.end);
    } else {
      // submitEvent();
    }
  };
  return (
    <div className="details-slide">
      <div className="details scheduling">
        <div className="main">
          <Title level={2}>{title}</Title>
          <EmployeeDetails activeEvent={activeEvent} />
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Text type="secondary">
              {intl.formatMessage({
                id: `app.scheduling.date`,
              })}
            </Text>
            <DatePicker
              style={{ width: "130px" }}
              value={
                activeEvent && activeEvent.start && moment(activeEvent.start)
              }
              onChange={onDateChange}
              format={"DD/MM/YYYY"}
              placeholder={intl.formatMessage({
                id: `"app.scheduling.date`,
              })}
              disabledDate={disabledDate}
              allowClear={false}
            />
          </div>
          <Space size="middle">
            <TimeRangePicker
              onStartChange={onStartChange}
              onEndChange={onEndChange}
              startText={intl.formatMessage({
                id: "app.plans.start",
              })}
              endText={intl.formatMessage({
                id: "app.plans.end",
              })}
              startValue={
                activeEvent &&
                (activeEvent.start_time_minutes ||
                  (type === "scheduling" && activeEvent.start))
                  ? moment(activeEvent["start"])
                  : undefined
              }
              endValue={
                activeEvent &&
                (activeEvent.start_time_minutes ||
                  (type === "scheduling" && activeEvent.start))
                  ? moment(activeEvent["end"])
                  : undefined
              }
              disabled={activeEvent?.approved}
              bordered={true}
              format={"HH:mm"}
              minuteStep={15}
              inputReadOnly={false}
              endOnNextDay={endOnNextDay}
            />
            <Checkbox
              checked={endOnNextDay}
              onChange={onEndOnNextDayChange}
              style={{ margin: "20px 0", paddingTop: "22px", width: "120px" }}
            >
              {intl.formatMessage({
                id: "app.forms.scheduling.end_hour_next_day",
              })}
            </Checkbox>
          </Space>
          <div style={{ height: "20px" }} />
          <OncallSelector
            onOncallChange={onOncallChange}
            activeEvent={activeEvent}
          />
          <Title level={4}>
            {<FormattedMessage id="app.scheduling.selectProviderTariff" />}
          </Title>
          <ProviderTariffSelector
            activeEvent={activeEvent}
            onSelectProviderTariff={onSelectProviderTariff}
            fromEmployee={fromEmployee}
          />
        </div>

        <div className="actions">
          <Button
            disabled={
              activeEvent && (!activeEvent.order_id || activeEvent.approved)
            }
            type="primary"
            onClick={() => onChangeSlide(1)}
          >
            {<FormattedMessage id="app.actions.continueToScheduling" />}
          </Button>
          <Button
            disabled={
              activeEvent &&
              (!activeEvent.order_id ||
                activeEvent.prospectus_id ||
                !activeEvent.employee_id ||
                (!activeEvent.tariff_id && !activeEvent.use_employee_tariff) ||
                activeEvent.ghostEmployeeId === activeEvent.employee_id)
            }
            onClick={submitChanges}
            loading={editLoading}
          >
            {<FormattedMessage id="app.actions.save" />}
          </Button>
          <div style={{ width: "10px" }} />
          <Button
            danger
            onClick={removeEvent}
            disabled={activeEvent && activeEvent.approved}
          >
            {<FormattedMessage id="app.actions.removeSchedulingEvent" />}
          </Button>
        </div>
      </div>

      <Walkthrough
        activeEvent={activeEvent}
        orders={orders}
        type={type}
        fromEmployee={fromEmployee}
      />
    </div>
  );
};

export default EditEventDetails;
